/* @flow */

import React, { Component } from 'react';


export default class Print extends Component {
  print() {
    window.print();
  }
  render() {
    return (
      <div className="Print">
        <input type="button" value={this.props.text} onClick={this.print} />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/print.js
 **/